import * as React from "react"
import {Box} from "@mui/material";
import {CardSeeker} from "@ui-seeker/core";

import ReverseMatcherTargetActionsZoom from "./Zoom";
import ReverseMatcherTargetActionsPagination from "./Pagination";


export default function ReverseMatcherTargetActions({ targetIndex, handleChangeIndex, isLoadingMapping }) {

	return <CardSeeker sx={{ width: 1}} contentProps={{ sx: { display: 'flex', justifyContent: 'space-between' } }}>
		<ReverseMatcherTargetActionsZoom />

		<ReverseMatcherTargetActionsPagination
			number={targetIndex}
			setNumber={handleChangeIndex}
			isLoadingMapping={isLoadingMapping}
		/>

		<Box />
	</CardSeeker>
}